// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"90bd93f8","703":"1fc87636","787":"c7b1b797"}[chunkId] + ".chunk.js";
};